export default "__VITE_ASSET__CWj0TTj2__"